import {useEffect, useRef} from 'react';
import divider from '../images/alnair-divider.png';
import blockDivider from '../images/block-divider.png';
import homeBackground from '../images/home-background.png';
import '../styles/Home.scss';
import intro from '../video/alnair-promo.mp4';
import {HomeUseCasesBlock} from "./HomeUseCasesBlock";
import 'animate.css';
import {HomeTeamSlider} from "./HomeTeamSlider";
import {HomeStoryBehind} from "./HomeStoryBehind";
import {useInView} from "react-intersection-observer";
import {Row, Col} from 'react-simple-flex-grid';

function Home(props: { title: string }) {
    const vidRef = useRef<any>(null);

    useEffect(() => {
        document.title = props.title;
    });

    const [ref, inView] = useInView({
        triggerOnce: true,
        threshold: 0.5
    })

    const [alnairSectionRef, alnairSectionInView] = useInView({
        triggerOnce: true,
        threshold: 0.5
    })

    const [howItWorksSectionRef, howItWorksSectionInView] = useInView({
        triggerOnce: true,
        threshold: 0.2
    })

    const promoLink = 'https://www.youtube.com/watch?v=tm029a824qM&list=UULFVYd_qsRRTZFiRH8lPJoU3w&index=45&ab_channel=SoftServe'

    const openVideo = (link: string) => {
        window.open(link, '_blank')
    }

    const scrollToAlnairSection = () => {
        const navbarHeight = window.innerWidth <= 932 ? 80 : 100;

        const targetElement = document.querySelector('.alnair-section') as HTMLElement;

        if (targetElement) {
            const targetPosition = targetElement.offsetTop - navbarHeight;

            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
            });
        }
    }


    return <>
        <div className="home-page">
            <div ref={ref} className={inView ? 'background-image slideInUp' : 'background-image'}>
                <div className="section-shadow section-shadow-from-top"></div>
                <img src={homeBackground} alt="Alnair"></img>
                <div className="know-your-future">
                    <Row align="bottom">
                        <Col xs={12} sm={6}>
                            <h1 className="future-title">KNOW YOUR FUTURE</h1>
                            <p className="future-question">
                                Do you ever think what will you do in the future digital world?
                            </p>
                        </Col>
                        <Col span={0} sm={6}>
                            <div className="discover-wrapper" onClick={scrollToAlnairSection}>
                                <span className="discover-title">Discover</span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="14" viewBox="0 0 30 14"
                                     fill="none">
                                    <path d="M2 2L15.65 11L28 2" stroke="white" strokeWidth="4"/>
                                </svg>
                            </div>
                        </Col>
                    </Row>
                </div>
                <div className="section-shadow section-shadow-from-bottom"></div>
            </div>
            <div ref={alnairSectionRef} className={alnairSectionInView ? 'alnair-section slideInUp' : 'alnair-section'}>
                <div className="section-shadow section-shadow-from-top"></div>
                <img className="divider" src={divider} alt="divider"/>
                <div className="alnair-description-container">
                    <div className="alnair-col-1">
                        <h3 className="alnair-title">ALNAIR</h3>
                        Meta-human, who came from distant digital universe #FTF2100, called
                        Neon Dust.
                    </div>
                    <div className="alnair-col-2">
                        Alnair, who’s name means ‘The Bright One’, connected with us
                        exclusively to give the prediction about future in Metavese to enyone
                        who is brave enough to interact with them.
                    </div>
                    <div className="alnair-col-3">
                        This digital universe is inhabited with the caste of meta-oracles.
                        They travel between different planets and digital universes to share
                        the insights about the future for local residents.
                    </div>
                </div>

                <div className="alnair-video-wrapper">
                    <video
                        className="alnair-video"
                        ref={vidRef}
                        autoPlay
                        playsInline
                        muted
                        loop
                    >
                        <source src={intro} type="video/mp4"/>
                    </video>
                    <div className="promo-video-footer">
                        <div className="footer-actions">
                            <h5 className="footer-title">Watch promo video</h5>
                            <div className="play-button" onClick={() => openVideo(promoLink)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"
                                     viewBox="0 0 40 40"
                                     fill="none">
                                    <circle cx="20" cy="20" r="19.5" stroke="white"/>
                                    <path
                                        d="M25.5 19.634C26.1667 20.0189 26.1667 20.9811 25.5 21.366L18.75 25.2631C18.0833 25.648 17.25 25.1669 17.25 24.3971L17.25 16.6029C17.25 15.8331 18.0833 15.352 18.75 15.7369L25.5 19.634Z"
                                        fill="white"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="section-shadow section-shadow-from-bottom"></div>
            </div>

            <div ref={howItWorksSectionRef}
                 className={howItWorksSectionInView ? 'how-it-works-background slideInUp' : 'how-it-works-background'}>
                <div className="section-shadow section-shadow-from-top"></div>
                <h1 className="how-it-works-title">HOW</h1>
                <h1 className="how-it-works-title">IT WORKS?</h1>
                <p className="how-it-works-description">
                    Fortune Teller Alnair is a GenAI-driven multi-modal immersive
                    experience.
                </p>
                <div className="how-blocks-container">
                    <div className="how-block">
                        <h3 className="block-title">#1 Initiation</h3>
                        <p className="block-text">
                            Meta-human Alnair is displayed on the screen in idle mode. The
                            visitor approaches and activates the experience with the haptics
                            device. When activating the experience, the visitor feels the
                            tactile sensation.
                        </p>
                    </div>
                    <img src={blockDivider} alt="Divider"></img>
                    <div className="how-block">
                        <h3 className="block-title">#2 Recognition</h3>
                        <p className="block-text">
                            Meta-human Alnair is displayed on the screen in idle mode. The
                            visitor approaches and activates the experience with the haptics
                            device. When activating the experience, the visitor feels the
                            tactile sensation.
                        </p>
                    </div>
                    <img src={blockDivider} alt="Divider"></img>
                    <div className="how-block">
                        <h3 className="block-title">#3 Prediction</h3>
                        <p className="block-text">
                            Meta-human Alnair is displayed on the screen in idle mode. The
                            visitor approaches and activates the experience with the haptics
                            device. When activating the experience, the visitor feels the
                            tactile sensation.
                        </p>
                    </div>
                    <img src={blockDivider} alt="Divider"></img>
                    <div className="how-block">
                        <h3 className="block-title">#4 Generation</h3>
                        <p className="block-text">
                            Meta-human Alnair is displayed on the screen in idle mode. The
                            visitor approaches and activates the experience with the haptics
                            device. When activating the experience, the visitor feels the
                            tactile sensation.
                        </p>
                    </div>
                </div>
                <div className="section-shadow section-shadow-from-bottom"></div>
            </div>

            <HomeUseCasesBlock/>
            <HomeTeamSlider/>
            <HomeStoryBehind/>
        </div>
    </>
}

export default Home;
